// extracted by mini-css-extract-plugin
module.exports = {"groupControl":"Tabs_groupControl__ehgih","selected":"Tabs_selected__42E0e"};